import { getRandomLightColor } from './colorUtils';

const sidebarFields = [
  { type: 'signature', label: 'Signature field' },
  { type: 'initials', label: 'Initials field' },
  { type: 'text', label: 'Text field' },
  { type: 'date', label: 'Date field' },
];

export const parseContractData = (data: any[]) => {
  // Process each level and preserve the level structure
  const levels = data.map((levelData, levelIndex) => {
    return {
      level: levelIndex + 1,
      signees: levelData.fields.map((field: any) => {
        return {
          name: field.name,
          email: field.email,
          signeeType: field.signeeType || 'Signer', // Ensure signeeType is included
          color: getRandomLightColor(),
          fields: sidebarFields,
          level: levelIndex + 1,
        };
      }),
    };
  });

  // Also provide a flattened version for backward compatibility
  const allSignees = levels.flatMap((level) => level.signees);

  return {
    contractDetails: {
      signees: allSignees,
      levels,
    },
  };
};
